import React from 'react';

const MaintenanceBanner = ({ onDismiss, message }) => {
    const defaultMessage = "Website Under Maintenance - You may experience some service disruptions. We're working to resolve any issues as quickly as possible.";

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-yellow-500 text-white py-3 shadow-lg z-50" role="alert">
            <div className="flex items-center justify-between max-w-7xl mx-auto">
                <div className="flex items-center">
                    {/* Warning Icon */}
                    <svg
                        className="h-5 w-5 mr-3 flex-shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>

                    {/* Message */}
                    <div className="flex-1">
                        <span className="font-medium">
                            ⚠️ {message || defaultMessage}
                        </span>
                    </div>
                </div>

                {/* Dismiss Button */}
                {onDismiss && (
                    <button
                        onClick={onDismiss}
                        className="ml-4 text-white hover:text-yellow-200 transition-colors duration-200"
                        aria-label="Dismiss maintenance notice"
                    >
                        <svg
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
};

export default MaintenanceBanner; 